import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      opacity: "0.8",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0.0478736 0.35421C0.135881 0.13866 0.330657 0 0.545452 0H11.4543C11.6691 0 11.8638 0.13866 11.9518 0.35421C12.0398 0.56976 12.0046 0.82203 11.8619 0.99861L7.63618 6.22812V11.4C7.63618 11.6273 7.51946 11.835 7.33466 11.9367C7.1499 12.0383 6.92875 12.0164 6.76348 11.88L4.58171 10.08C4.44437 9.96669 4.36354 9.78885 4.36354 9.6V6.22812L0.137789 0.99861C-0.00492542 0.82203 -0.040106 0.56976 0.0478736 0.35421ZM1.76007 1.2L5.31664 5.60139C5.40538 5.71122 5.45442 5.85306 5.45442 6V9.3L6.5453 10.2V6C6.5453 5.85306 6.59434 5.71122 6.68308 5.60139L10.2397 1.2H1.76007Z",
      fill: "#1F2D43"
    }, null, -1)
  ])))
}
export default { render: render }